import React from 'react';
import { Globe, ImageOff } from 'lucide-react';

const Img = ({ src, className, testId }) => (src
  ? <img src={src} alt="" className={`${className} object-cover bg-white`} data-testid={testId} />
  : <div className={`${className} bg-gray-200 flex items-center justify-center text-gray-400`} data-testid={testId}><ImageOff size={22} /></div>);

// Facebook / WhatsApp link cards rendered from the Open Graph data of the pre-rendered page
export const SocialPreview = ({ social }) => {
  if (!social) return null;
  const { domain, title, description, image } = social;
  return (
    <div className="pt-3" data-testid="social-preview">
      <p className="text-xs font-medium text-gray-700 mb-2 flex items-center gap-1"><Globe size={12} /> Aperçu du partage sur les réseaux (Open Graph)</p>
      <div className="grid sm:grid-cols-2 gap-3">
        <div data-testid="social-preview-facebook">
          <p className="text-[11px] text-gray-500 mb-1">Facebook / LinkedIn</p>
          <div className="border border-gray-300 rounded-md overflow-hidden bg-white max-w-[360px]">
            <Img src={image} className="w-full h-44" testId="social-preview-facebook-image" />
            <div className="bg-[#f0f2f5] px-3 py-2">
              <p className="text-[11px] uppercase text-gray-500 truncate" data-testid="social-preview-facebook-domain">{domain}</p>
              <p className="text-sm font-semibold text-gray-900 leading-tight line-clamp-2" data-testid="social-preview-facebook-title">{title}</p>
              <p className="text-xs text-gray-600 line-clamp-1" data-testid="social-preview-facebook-description">{description}</p>
            </div>
          </div>
        </div>
        <div data-testid="social-preview-whatsapp">
          <p className="text-[11px] text-gray-500 mb-1">WhatsApp</p>
          <div className="bg-[#e7ffdb] rounded-lg p-1.5 max-w-[320px] shadow-sm">
            <div className="flex gap-2 bg-[#d9fdd3] rounded-md overflow-hidden">
              <Img src={image} className="w-24 h-24 shrink-0" testId="social-preview-whatsapp-image" />
              <div className="py-1.5 pr-2 min-w-0">
                <p className="text-sm font-medium text-gray-900 leading-tight line-clamp-2" data-testid="social-preview-whatsapp-title">{title}</p>
                <p className="text-xs text-gray-600 line-clamp-2" data-testid="social-preview-whatsapp-description">{description}</p>
                <p className="text-[11px] text-gray-500 truncate lowercase" data-testid="social-preview-whatsapp-domain">{domain}</p>
              </div>
            </div>
            <p className="text-xs text-[#027eb5] px-1 pt-1 truncate">{`https://${(domain || '').toLowerCase()}`}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SocialPreview;
